import { Mail, MapPin, Phone, Plane } from 'lucide-react';
import {
  SW_BRAND,
  SW_BRAND_ACCENT,
  SW_DISCLAIMER,
  SW_DOMAIN,
  SW_EMAIL,
  SW_LOGO_BY,
  SW_PHONE_DISPLAY,
  SW_PHONE_RAW,
  SW_TAGLINE,
} from '../config';

const brandBase = SW_BRAND.endsWith(SW_BRAND_ACCENT)
  ? SW_BRAND.slice(0, SW_BRAND.length - SW_BRAND_ACCENT.length)
  : SW_BRAND;

const EXPLORE = [
  { label: 'Search Flights', href: '#swp-search' },
  { label: 'Bag Allowance', href: '#swp-baggage' },
  { label: 'Top Routes', href: '#swp-routes' },
  { label: 'Fare Tips', href: '#swp-tips' },
];

const COMPANY = [
  { label: 'About the Desk', href: '#swp-contact' },
  { label: 'Talk to Us', href: '#swp-contact' },
  { label: 'Help Centre', href: '#swp-faq' },
  { label: 'Back to Top', href: '#swp-top' },
];

const POLICIES = [
  { label: 'Legal Notice', href: '#swp-legal' },
  { label: 'Fare Conditions', href: '#swp-legal' },
  { label: 'Brand & Trademark Use', href: '#swp-legal' },
  { label: 'Independence Statement', href: '#swp-legal' },
];

const PAYMENTS = ['VISA', 'MC', 'AMEX', 'DISC', 'PayPal'];

export default function SwFooter() {
  const year = new Date().getFullYear();

  return (
    <footer className="swp-footer">
      <div className="swp-shell">
        <div className="swp-footer__grid">
          <div>
            <a className="swp-logo" href="#swp-top">
              <span className="swp-logo__mark">
                <Plane size={18} aria-hidden />
              </span>
              <span className="swp-logo__text">
                <span className="swp-logo__name">
                  {brandBase}
                  <span className="swp-logo__accent">
                    {brandBase === SW_BRAND ? '' : SW_BRAND_ACCENT}
                  </span>
                </span>
                <span className="swp-logo__by">by {SW_LOGO_BY}</span>
              </span>
            </a>
            <p className="swp-footer__about">
              {SW_TAGLINE}. Independent assistance available on {SW_DOMAIN}.
            </p>
          </div>

          <div>
            <h4>Explore</h4>
            <ul>
              {EXPLORE.map((item) => (
                <li key={item.label}>
                  <a href={item.href}>{item.label}</a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4>Company</h4>
            <ul>
              {COMPANY.map((item) => (
                <li key={item.label}>
                  <a href={item.href}>{item.label}</a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4>Policies</h4>
            <ul>
              {POLICIES.map((item) => (
                <li key={item.label}>
                  <a href={item.href}>{item.label}</a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4>Get In Touch</h4>
            <ul className="swp-footer__contact">
              <li>
                <Phone size={16} aria-hidden />
                <span>
                  <a href={`tel:${SW_PHONE_RAW}`}>
                    <strong>{SW_PHONE_DISPLAY}</strong>
                  </a>
                  <small>Round-the-clock booking help</small>
                </span>
              </li>
              <li>
                <Mail size={16} aria-hidden />
                <span>
                  <a href={`mailto:${SW_EMAIL}`}>
                    <strong>{SW_EMAIL}</strong>
                  </a>
                  <small>Email replies within one business day</small>
                </span>
              </li>
              <li>
                <MapPin size={16} aria-hidden />
                <span>
                  <strong>{SW_DOMAIN}</strong>
                  <small>Independent travel booking desk</small>
                </span>
              </li>
            </ul>
          </div>
        </div>

        <div className="swp-disclaimer" id="swp-legal">
          <h4>Disclaimer</h4>
          {SW_DISCLAIMER.map((text) => (
            <p key={text.slice(0, 40)}>{text}</p>
          ))}
        </div>

        <div className="swp-footer__bar">
          <span>
            © {year} {SW_BRAND} · {SW_DOMAIN}. All rights reserved.
          </span>
          <div className="swp-footer__pay">
            {PAYMENTS.map((label) => (
              <span key={label}>{label}</span>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}
